/* eslint-disable max-len */
import { defineMessages } from 'react-intl';

const messages = defineMessages({
  defaultApiErrorMessage: {
    id: 'defaultApiErrorMessage',
    defaultMessage: 'A problem occured while processing your request.',
  },
  invalidModification3: {
    id: 'invalidModification3',
    defaultMessage: 'Invalid modification 3 code provided.',
  },
  invalidModification5: {
    id: 'invalidModification5',
    defaultMessage: 'Invalid modification 5 code provided.',
  },
  invalidModification5PlateWell96: {
    id: 'invalidModification5PlateWell96',
    defaultMessage: 'Invalid modification 5 code provided for 96 well plate.',
  },
  invalidModification5PlateWell384: {
    id: 'invalidModification5PlateWell384',
    defaultMessage: 'Invalid modification 5 code provided for 384 well plate.',
  },
  invalidOligoSequenceLen: {
    id: 'invalidOligoSequenceLen',
    defaultMessage:
      'Invalid Oligo sequence. Length should be between 5 and 100 bases.',
  },
  invalidOligoSequenceBases: {
    id: 'invalidOligoSequenceBases',
    defaultMessage:
      'Invalid Oligo sequence. Sequence contains invalid bases. Make sure bases are uppercase letters or numerical characters.',
  },
  invalidOligoNameLen: {
    id: 'invalidOligoNameLen',
    defaultMessage: 'Invalid Oligo name. Length should be under 80 characters.',
  },
  invalidOligoNameChars: {
    id: 'invalidOligoNameChars',
    defaultMessage:
      'Invalid Oligo name. Oligo name should only contain letters, numbers and special characters other than ( ,\'/"~ ).',
  },
  senseModificationIncompatible: {
    id: 'senseModificationIncompatible',
    defaultMessage:
      'Synthesis scale {synthesisScale} and primer modification {primerModification} are not compatible for plate {plateName}:(row {rowNumber}, column {columnNumber}).',
  },
  invalidModificationCode: {
    id: 'invalidModificationCode',
    defaultMessage: 'Invalid primer modification code: {modificationCode}.',
  },
  invalidOligoPlateSetting: {
    id: 'invalidOligoPlateSetting',
    defaultMessage:
      'Invalid oligo plate configuration setting: {configurationKey}.',
  },
  invalidBaseLimitCartridgePurification: {
    id: 'invalidBaseLimitCartridgePurification',
    defaultMessage:
      'The oligo length has to be between 7 and 55 bases in order to be purified by cartridge.',
  },
  invalidScaleForCartridgePurification: {
    id: 'invalidScaleForCartridgePurification',
    defaultMessage:
      'Cartridge purification is not available for 25 nmole or 10 umole synthesis scales. Please select a different scale.',
  },
  invalidHPLCPurificationFor25nmole: {
    id: 'invalidHPLCPurificationFor25nmole',
    defaultMessage:
      'HPLC purification for this synthesis scale is not available. Please select 50 nmole scale or greater.',
  },
  invalidPagePurificationFor25nmole: {
    id: 'invalidPagePurificationFor25nmole',
    defaultMessage:
      'PAGE purification for this synthesis scale is not available. Please select a larger synthesis scale.',
  },
  invalidBaseLimitForSynthesisScale: {
    id: 'invalidBaseLimitForSynthesisScale',
    defaultMessage:
      'The minimum length for 25 nmole Scale is 10 bases. Please select a higher synthesis scale for lengths between 5 and 9.',
  },
  invalidBaseLimitDesaltedPurification: {
    id: 'invalidBaseLimitDesaltedPurification',
    defaultMessage:
      'The length for desalted oligos has to be between 5 and 100 bases.',
  },
  invalid3Prime5PrimeModifications: {
    id: 'invalid3Prime5PrimeModifications',
    defaultMessage:
      "The 5'' modification ({5primeModification}) and 3'' modification ({3primeModification}) requested are not compatible and can not be manufactured on the same oligo sequence.",
  },
  invalid3PrimeModificationScale: {
    id: 'invalid3PrimeModificationScale',
    defaultMessage:
      "The 3'' Modification requested is not available at the ({3primeModification}) scale.",
  },
  invalid5PrimeModificationScale: {
    id: 'invalid5PrimeModificationScale',
    defaultMessage:
      "The 5'' Modification requested is not available at the ({5primeModification}) scale.",
  },
  invalid5PrimeModificationPurification: {
    id: 'invalid5PrimeModificationPurification',
    defaultMessage:
      "The 5'' modification {5primeModification} is not available with cartridge purification {purification}. Please select a different purification method.",
  },
  invalid5PrimeModificationHplcPurification: {
    id: 'invalid5PrimeModificationHplcPurification',
    defaultMessage:
      ' The 5 modification requested requires HPLC or PAGE purification.',
  },
  oligoPlateWellNotFound: {
    id: 'oligoPlateWellNotFound',
    defaultMessage:
      'Could not find well for plate name: {plateName}, row: {rowNumber}, column: {columnNumber}.',
  },
  oligoPlateNotFound: {
    id: 'oligoPlateNotFound',
    defaultMessage: 'Could not find plate with name: {plateName}.',
  },
  oligoPlatesNotFound: {
    id: 'oligoPlatesNotFound',
    defaultMessage: 'Could not find plates.',
  },
  invalidWellVolume: {
    id: 'invalidWellVolume',
    defaultMessage: 'Invalid well volume: {wellVolume}.',
  },
  invalidVolumeNormalizationQty: {
    id: 'invalidVolumeNormalizationQty',
    defaultMessage:
      ' Maximum quantity for Volume normalization is {maximumQuantity}. Minimum quantity for Volume normalization is {minimumQuantity}.',
  },
  invalidConcentrationNormalizationQty: {
    id: 'invalidConcentrationNormalizationQty',
    defaultMessage:
      ' Maximum quantity for Concentration normalization is {maximumQuantity} . Minimum quantity for Concentration normalization is {minimumQuantity} .',
  },
  aliquotesNotAllowed: {
    id: 'aliquotesNotAllowed',
    defaultMessage:
      'Aliquots are not allowed with current normalization settings.',
  },
  pooledPlatesNotAllowed: {
    id: 'pooledPlatesNotAllowed',
    defaultMessage:
      'Pooled plates are not allowed with current normalization settings.',
  },
  remaindersNotAllowed: {
    id: 'remaindersNotAllowed',
    defaultMessage:
      'Remainders are not allowed without aliquots or plate pooling.',
  },
  aliquotsMinError: {
    id: 'aliquotsMinError',
    defaultMessage: 'Minimum quantity for aliquots is {minimumQuantity}.',
  },
  aliquotsLessThanMinVolume: {
    id: 'aliquotsLessThanMinVolume',
    defaultMessage: 'Minimum volume for aliquots is {minimumQuantity}.',
  },
  aliquotsMaxVolumeError: {
    id: 'aliquotsMaxVolumeError',
    defaultMessage: 'Aliquots should not exceed {maximumQuantity}.',
  },
  invalidPooledPlateVolume: {
    id: 'invalidPooledPlateVolume',
    defaultMessage:
      'Pooled plate volume must be between {minimumQuantity} and {maximumQuantity}.',
  },
  invalid25NmoleOligo: {
    id: 'invalid25NmoleOligo',
    defaultMessage:
      'Please select a synthesis scale of 50 nmole or higher for the internal modifications F, O, E and Z.',
  },
  invalidPlateName: {
    id: 'invalidPlateName',
    defaultMessage: 'Plate name {plateName} is invalid.',
  },
  plateNameExists: {
    id: 'plateNameExists',
    defaultMessage: 'A plate with name {plateName} already exists.',
  },
  invalidCartRequest: {
    id: 'invalidCartRequest',
    defaultMessage: 'Invalid cart request.',
  },
  missingFileUrl: {
    id: 'missingFileUrl',
    defaultMessage: 'The file path or URL cannot be empty.',
  },
  invalidDelimiter: {
    id: 'invalidDelimiter',
    defaultMessage:
      'The file format is invalid. The online oligo order system can only accept Excel files (.xls/.xlsx) and comma (.csv) or tab delimited (.txt) files.',
  },
  dnaTubeInvalidNoColumns: {
    id: 'dnaTubeInvalidNoColumns',
    defaultMessage:
      'The file should have minimum 5 columns and maximum 9 columns.',
  },
  dnaTubeMissingMandatoryField: {
    id: 'dnaTubeMissingMandatoryField',
    defaultMessage:
      'Mandatory fields are missing from the file. Please enter all mandatory fields (oligo sequence, oligo name, researcher name, synthesis scale and purification) and resubmit.',
  },
  dnaTubeInvalidTubeFile: {
    id: 'dnaTubeInvalidTubeFile',
    defaultMessage: 'The DNA Tube File is Invalid.',
  },
  dnaTubeInvalidTubeFileEmpty: {
    id: 'dnaTubeInvalidTubeFileEmpty',
    defaultMessage: 'The DNA Tube File is Empty.',
  },
  dnaTubeInvalidTubeFileEmptyExtended: {
    id: 'dnaTubeInvalidTubeFileEmptyExtended',
    defaultMessage:
      'The DNA Tube File is Empty. Make sure you have at least one plate name and at least one row.',
  },
  dnaPlateInvalidNoOfColumns: {
    id: 'dnaPlateInvalidNoOfColumns',
    defaultMessage:
      'The file should have 7 columns. Please make sure for each oligo (line) all the mandatory columns (plate name, row, column, oligo name and oligo sequence) contain appropiate values and none of them are empty. You may download our ordering template from the link above. If you continue having problems contact our customer service representatives for assistance.',
  },
  dnaPlateMissingMandatoryFields: {
    id: 'dnaPlateMissingMandatoryFields',
    defaultMessage:
      'Mandatory fields are missing from the file. Please enter all mandatory fields (plate name, row, column, oligo name, and oligo sequence) and resubmit.',
  },
  dnaPlateEmptyFile: {
    id: 'dnaPlateEmptyFile',
    defaultMessage: 'The DNA Plate File is Empty.',
  },
  dnaPlateInvalidColumnNo: {
    id: 'dnaPlateInvalidColumnNo',
    defaultMessage:
      'The Column number must be between 1 - 12(for 96 wells) or 1 - 24(for 384 wells). Please correct and resubmit.',
  },
  dnaPlateInvalidRow: {
    id: 'dnaPlateInvalidRow',
    defaultMessage:
      'The Row must be between A - H(for 96 wells) or A - P(for 384 wells). Please correct and resubmit.',
  },
  dnaPlateDuplicateWell: {
    id: 'dnaPlateDuplicateWell',
    defaultMessage:
      'Your file has either two or more wells with the same rows and column. Please correct your file and reupload.',
  },
  dnaPlateDuplicatePlate: {
    id: 'dnaPlateDuplicatePlate',
    defaultMessage:
      'Your file has either two or more plates with the same name. Please correct your file and reupload.',
  },
  dnaPlateHeaderEmptyFile: {
    id: 'dnaPlateHeaderEmptyFile',
    defaultMessage: 'The Plate Header File is empty.',
  },
  dnaPlateInvalidPlateHeaderFile: {
    id: 'dnaPlateInvalidPlateHeaderFile',
    defaultMessage: 'The Plate Header File is Invalid.',
  },
  invalidFileExtension: {
    id: 'invalidFileExtension',
    defaultMessage:
      'The file format is invalid. The online oligo order system can only accept Excel files (.xls/.xlsx) and comma (.csv) or tab delimited (.txt) files.',
  },
  invalidCsvFile: {
    id: 'invalidCsvFile',
    defaultMessage: 'Invalid CSV file.',
  },
  invalidWell: {
    id: 'invalidWell',
    defaultMessage: 'Invalid well volume.',
  },
  invalidCombinations: {
    id: 'invalidCombinations',
    defaultMessage: 'Details provided are not correct for DNA upload',
  },
  invalidTemplateFile: {
    id: 'invalidTemplateFile',
    defaultMessage: 'Uploaded file is invalid. Upload valid DNA Template file.',
  },
  invalidRowCharacters: {
    id: 'invalidRowCharacters',
    defaultMessage:
      'The Row {rowNumber} contains invalid characters. Row value should only have single alphabet.',
  },
});

export default messages;
